// BHP-1070: onboarding screen for a freshly provisioned account without a
// customer. Shown by OnboardingGate; creating a customer re-routes to the app.
// Mirrors the app's auth-box card look (same classes as the login screens).
import OnboardingCustomerForm from './OnboardingCustomerForm';

export default function Onboarding(): JSX.Element {
  return (
    <div id="wrapper">
      <div className="theme-cyan">
        <div className="hide-border">
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="card">
                  <div className="header">
                    <h4 className="mb-1">Welcome to Bizhost</h4>
                    <p className="text-muted mb-0">
                      Create your customer profile to finish setting up your
                      account.
                    </p>
                  </div>
                  <div className="body">
                    <OnboardingCustomerForm />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
